

<div *ngIf="(userState?.user$ | async) as user" (click)="menu.toggle($event)" class="flex gap-2 align-items-center w-full">

  <app-user-avatar [user]="user" [cacheImg]="false"></app-user-avatar>

  <span *ngIf="showName" class="user-name font-medium text-overflow-ellipsis overflow-hidden">
    {{ user.orgUsers | userNameOrEmail:selectedOrg.getCurrentValue():true }}
  </span>

</div>

<p-menu #menu [popup]="true" [model]="items" appendTo="body" styleClass="user-menu-item-menu"></p-menu>
